import {
  CustomerActivityAction,
  CustomerActivityDirection,
  CustomerActivitySource,
  CustomerActivityType,
  ICustomerActivity,
} from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';

export class CustomerActivity implements ICustomerActivity {
  id!: string;
  source!: CustomerActivitySource;
  direction!: CustomerActivityDirection | null;
  type!: CustomerActivityType | null;
  action!: CustomerActivityAction | null;
  title!: string | null;
  description!: string | null;
  @Type(() => Date)
  openedAt!: Date | null;
  @Type(() => Date)
  closedAt!: Date | null;
  externalUri!: string | null;
}
